module.exports = "<h2 class=\"gw-titles-heading\">\n    <ng-transclude></ng-transclude>\n</h2>"